import React, { PropTypes } from 'react'

const DEFAULT_QUERY = function () {
  return {}
}

export default React.createClass({

  propTypes: {
    app       : React.PropTypes.object.isRequired,
    props     : React.PropTypes.object,
    component : React.PropTypes.any.isRequired
  },

  componentDidMount() {
    this.props.app.listen(this.rollforward, this)
  },

  componentWillUnmount() {
    this.props.app.ignore(this.rollforward, this)
  },

  rollforward() {
    this.forceUpdate()
  },

  render() {
    let { app, props, component } = this.props

    let query = component.query || DEFAULT_QUERY

    return React.createElement(component, { app, ...props, ...query(app.state, props) })
  }

})



/** WEBPACK FOOTER **
 ** ./web/static/lib/relay.js
 **/